
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/integrations/slack",
      function () {
        return require("private-next-pages/integrations/slack.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/integrations/slack"])
      });
    }
  